import { Component, Input, OnChanges } from '@angular/core';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { CultivationItemViewerComponent } from './cultivation-item-viewer/cultivation-item-viewer.component';

@Component({
  selector: 'vw-hierarchy-item',
  imports: [
    SharedModule,
    TranslateModule,
    NgClass,
    CultivationItemViewerComponent,
  ],
  templateUrl: './hierarchy-item.component.html',
  styleUrl: './hierarchy-item.component.scss'
})
export class HierarchyItemComponent implements OnChanges {
  @Input() hierarchy: any;
  actionRequired: boolean = false;

  ngOnChanges() {
    //TODO - Implement this method
    if ((this.hierarchy as any).actionRequired) {
      this.actionRequired = true;
    }
  }
}
